module.exports = __webpack_public_path__ + "static/img/RH06.4240e1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/RH06.jpg
// module id = YPdH
// module chunks = 1